import React, { Component } from 'react';
import { addBonusDialogueStyles } from '../styles';

import { MyPATTextField, MyPATDropdown} from "../../common/index";
// import MyPATCalendar from "../../common/MyPATCalendar";
import TextField from '@material-ui/core/TextField';
import {
    WithStyles,
    Modal,
    Card,
    CardHeader,
    IconButton,
    Typography,
    CardContent,
    Grid,
    withStyles,
    Button,
} from "@material-ui/core";
import {
  CloseOutlined as CloseIcon
} from '@material-ui/icons';

export interface ComboCoursePopupProps extends WithStyles<typeof addBonusDialogueStyles> {
    isDialogOpen: boolean;
    label: string
}
 
export interface ComboCoursePopupState {
    isDialogOpen: boolean;
    label: string
}
 
class ComboCoursePopup extends Component<ComboCoursePopupProps, ComboCoursePopupState> {
    constructor(props: ComboCoursePopupProps) {
        super(props);
        this.state = { 
          isDialogOpen : true,
          label : ""
        };
    }

    handlePopUpClose= () =>{
      this.setState({
        isDialogOpen : false
      })
    }
    handleDropDownChange= (e: any) => {
      this.setState({
        label : e.target.value
      })
    }
    render() { 
        const { isDialogOpen, classes  } = this.props;
        let courses = ["Standard Course", "Goals"];
        console.log(this.state.label);
        return (  
            <Modal
        className={[
          classes.fontSizeLG,
          classes.fontWeight500,
          classes.modal,
        ].join(" ")}
        open={this.state.isDialogOpen}
      >
        <div >
          <Card >
            <CardHeader
              className={classes.modalHeader}
              action={
                <IconButton
                  aria-label="settings"
                  onClick={this.handlePopUpClose}
                >
                  <CloseIcon className={classes.fontSizeLG} />
                </IconButton>
              }
              title={
                <Typography
                  align="center"
                  className={[classes.fontWeight500, classes.fontSizeLG].join(
                    " "
                  )}
                >
                  Create New Combo Course
                </Typography>
              }
            />
            <CardContent>
                <Grid item xs={8}>
                    <Typography
                      variant="body1"
                      gutterBottom
                      className={classes.fontSizeMD}
                    >
                        Course Basic Details* 
                    </Typography>
                </Grid>
                <Grid  container className={classes.text}>
                    <Grid>
                        <Typography
                            variant="body1"
                            gutterBottom
                            className={classes.fontSizeMD}
                        >
                            Course Name
                        </Typography>
                        <MyPATTextField
                            // fullWidthControl
                            inputId="CourseName"
                            name="CourseName"
                        />
                    </Grid>
                    <Grid>
                        <Typography
                        variant="body1"
                        gutterBottom
                        className={classes.fontSizeMD}
                        >
                            SKU
                        </Typography>
                        <MyPATTextField
                            // fullWidthControl
                            inputId="SKU"
                            name="SKU"
                            placeholder="E.g. JEE"
                        />
                        -
                        <MyPATTextField
                            // fullWidthControl
                            inputId="number"
                            name="number"
                        />
                    </Grid>
                </Grid>
                <Grid  container  className={classes.text}>
                    <Grid item xs={6}>
                        <Typography
                            variant="body1"
                            gutterBottom
                            className={classes.fontSizeMD}
                        >
                            Combo Course to be created from
                        </Typography>
                        <MyPATDropdown 
                          placeholder="Select combo course"
                          dropdownItems={courses}
                          selectedItem = {this.state.label}
                          onChange={(e: any) => this.handleDropDownChange(e)}
                          />
                    </Grid>  
                    <Grid item xs={6}>
                        <Typography
                            variant="body1"
                            gutterBottom
                            className={classes.fontSizeMD}
                        >
                            Select Course(s)
                        </Typography>
                        <MyPATDropdown 
                          placeholder="Select Course"
                          dropdownItems={courses}
                        //   selectedItem = {this.state.label}
                        //   onChange={this.handleDateFilterChange}
                          />
                    </Grid>                   
                </Grid>
                <Grid  container>
                    <Grid item xs={12}>
                        <Typography
                            variant="body1"
                            gutterBottom
                            className={classes.fontSizeMD}
                        >
                            Select Primary Course Plan
                        </Typography>
                        <MyPATDropdown 
                          placeholder="Select Course"
                          dropdownItems={courses}
                        //   selectedItem = {this.state.label}
                        //   onChange={this.handleDateFilterChange}
                          />
                    </Grid>
                </Grid>
                <Grid container className={classes.text}>
                  <Grid item xs={6}>
                    <Typography>Start Date :</Typography>  
                      <TextField
                          id="StartDate"
                          type="date"
                          // defaultValue={startDate}
                          variant="outlined"
                          placeholder="Start Date"
                          // onChange={this.handleStartDateChange.bind(this)}
                          // fullWidth margin="dense"
                        />
                  </Grid>
                  <Grid item xs={6}> 
                      <Typography>End Date :</Typography>
                        <TextField
                          id="EndDate"
                          type="date"
                          // defaultValue={endDate}
                          placeholder="End Date"
                          variant="outlined"
                          // onChange={this.handleEndDateChange.bind(this)}
                          // fullWidth margin="dense"
                        />
                  </Grid>
                </Grid>
                <Grid item xs={6}>
                  <Typography
                      variant="body1"
                      gutterBottom
                      className={classes.fontSizeMD}
                  >
                      Course Admin
                  </Typography>
                  <MyPATTextField
                      // fullWidthControl
                      inputId="CourseAdmin"
                      name="CourseAdmin"
                  />
              </Grid>
            </CardContent>
          </Card>
        </div>
       </Modal>
        );
    }
}
 // @ts-ignore
export default withStyles(addBonusDialogueStyles)(ComboCoursePopup);